import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TenantListComponent } from '..';
import { environment } from '../../../../environments/environment';
import { TenantData } from '../../../@core/interfaces/masters/tenant';

@Component({
  selector: 'ngx-contact-administartor',
  templateUrl: './contact-administartor.component.html',
  styleUrls: ['./contact-administartor.component.css']
})
export class ContactAdministartorComponent implements OnInit {
  @ViewChild('editTenantComp') tenantTabInstance: TenantListComponent;
  @Output() dataEvent: EventEmitter<any> = new EventEmitter<any>();
  isEditTenant: boolean= false;
  tenantData: any;
  fromtenantId: string = localStorage.getItem("tenantId");
  protected readonly unsubscribe$ = new Subject<void>();
  isSuperAdmin: boolean =false;
  constructor(protected tenantSrvc: TenantData, protected cd: ChangeDetectorRef) { }


  ngOnInit(): void {
    this.fetchTenant();
  }
  get apiUrl(): string {
    return environment.apiUrl;
  }
  fetchTenant(){
    this.tenantSrvc.getById(`${this.apiUrl}/tenants/${this.fromtenantId}/tenantmst/${this.fromtenantId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.tenantData = data;
      if(data.isSuperAdmin == "true")
      this.isSuperAdmin = true;
      console.log(this.isSuperAdmin,"@@@@@@@@@@@@@@@@",this.tenantData);
      this.cd.detectChanges()
    }, (error) => {

    }, () => {
     
    });
  }
  onClose(){
    this.isEditTenant = false;
    this.dataEvent.emit();
  }
  editTenant() {
   
    this.isEditTenant = true;
    this.tenantTabInstance.callEdit(this.tenantData);
    // this.cd.detectChanges();
  }
  refreshUser(event) {
    this.isEditTenant = false;
    this.dataEvent.emit();
  }

}
